import { singleFlightTokenRefresh } from 'pages/Auth/utils';
import { IRefreshAccessTokenResponse } from './types';

export const refreshAccessToken = async (): Promise<IRefreshAccessTokenResponse | null> => {
  const result = await singleFlightTokenRefresh();
  return result.kind === 'success' ? { access: result.access } : null;
};

export const memoizedRefreshToken = refreshAccessToken;
